import request from '../util/request';
import { extend } from '../util/jquery';
import { REQUEST_TIMEOUT } from './constant';
import { VERSION } from '../var';

export default class DataSource {
    constructor(options = {}) {
        this._options = {
            method: 'get',
            timeout: REQUEST_TIMEOUT,
            transformationPipeline: []
        };
        this._mergeOptions(options);
    }
    options(options) {
        if (arguments.length === 0) {
            return this._options;
        }
        this._mergeOptions(options);
        return this;
    }
    execute(params = {}) {
        params.trackMarketData = VERSION; // for usage tracking
        // for loop call change session, it will not updated when it is false
        if (params.updateLastAccessTime) {
            delete params.updateLastAccessTime;
        }
        const config = {
            method: this._options.method,
            url: this._options.url,
            timeout: this._options.timeout,
            headers: {
                Accept: 'application/json, text/plain, */*' // axios default header, we need keep otherwise the request cache will not deleted                
            }
        };
        params.instid = this._options.instid;
        config.headers[ 'X-Api-Requestid'] = this._getApiRequestId();

        if (this._options.accessToken) {
            config.headers.Authorization = `Bearer ${this._options.accessToken}`;
        } else {
            params.qs_wsid = this._options.sessionId;
        }
        extend(config.headers, this._options.headers);
        if (this._options.method.toLowerCase() === 'post') {
            const { qs_wsid, instid } = params;
            if (this._options.contentType === 'application/json') {
                config.headers['Content-Type'] = 'application/json';
                config.data = JSON.stringify(params.data);
            } else if (params.formData) {
                config.headers['Content-Type'] = 'multipart/form-data';
                config.data = params.formData;
            } else {
                config.headers['Content-Type'] =
                    'application/x-www-form-urlencoded;charset=UTF-8';
                config.data = extend({}, this._options.params, params);
                config.originalData = extend({}, config.data);
                config.transformRequest = [
                    function(data) {
                        const ret = [];
                        for (const key in data) {
                            ret.push(`${key}=${data[key]}`);
                        }
                        return ret.join('&');
                    }
                ];
            }
            // for post, add some parameters for splunk
            config.params = {
                instid
            };
            if (qs_wsid) {
                config.params.qs_wsid = qs_wsid;
            }
            if (this._options.responseType) {
                config.responseType = this._options.responseType;
            }
        } else {
            config.params = extend({}, this._options.params, params);
            
        }
        return request(this._options.axiosInstance, config).then(res => {
            return this._transform(
                res.data,
                res.config.params || res.config.data
            );
        });
    }
    _mergeOptions(options) {
        extend(this._options, options);
        if (
            options.transformationPipeline &&
            options.transformationPipeline.length
        ) {
            this._options.transformationPipeline =
                options.transformationPipeline;
        }
    }
    _transform(data, params) {
        this._options.transformationPipeline.forEach(transformation => {
            data = transformation(data, params);
        });
        return data;
    }
    _getApiRequestId() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                const r = (Math.random() * 16) | 0;
                const v = c === 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
    }
}
